class EmblaSlider extends HTMLElement {
  constructor() {
    super();

    this.viewport = this.querySelector(".embla__viewport");
    const options = {
      loop: this.dataset.loop === "true",
    };
    if (this.dataset.align) {
      options.align = this.dataset.align;
    }
    this.slider = EmblaCarousel(this.viewport, options);
  }
}

customElements.define("embla-slider", EmblaSlider);
